var moment = require("moment");
moment.locale('zh-cn');
export const auth = {
    data() {
        return {
            isWmLoading: false
        };
    },
    async mounted() {
        try {
            // 已经获取授权并获取到店铺信息
            console.log(this.$store.state.weimeng);
            if (this.$store.state.weimeng.code) {
                this.isWmLoading = true
                return
            }
            const data = this.qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
            });
            const res = await this.axios({
                url: "/weimob/WmPublic/ifAuthorization",
                method: "POST",
                data,
            });
            this.isWmLoading = true
            this.$store.commit('setWeiMeng', res.data)
        } catch (error) {
            console.log(error);
        }
  },
  
    filters: {
        formatDate(val) {
            return moment(val).format("YYYY/MM/DD HH:mm");
        }
    },
}